import { render, staticRenderFns } from "./BlockedUserCard.vue?vue&type=template&id=08d8e6c7&scoped=true&"
import script from "./BlockedUserCard.vue?vue&type=script&lang=js&"
export * from "./BlockedUserCard.vue?vue&type=script&lang=js&"
import style0 from "./BlockedUserCard.vue?vue&type=style&index=0&id=08d8e6c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d8e6c7",
  null
  
)

export default component.exports